import { useEffect, useLayoutEffect, useRef } from 'react';
import { Textarea } from '@chakra-ui/react';

// A textarea that grows to fit its text instead of scrolling. It also
// re-measures when its width changes, e.g. when its tab is first shown.
const AutoGrowTextarea = props => {
  const ref = useRef(null);
  const fit = () => {
    const el = ref.current;
    if (!el || !el.offsetWidth) return;
    el.style.height = 'auto';
    el.style.height = `${el.scrollHeight + 2}px`;
  };
  useLayoutEffect(fit, [props.value]);
  useEffect(() => {
    if (!ref.current || typeof ResizeObserver === 'undefined') return;
    let width = 0;
    let frame = 0;
    const observer = new ResizeObserver(([entry]) => {
      if (entry.contentRect.width !== width) {
        width = entry.contentRect.width;
        // Resize on the next frame: resizing inside the observer's callback
        // triggers the browser's "ResizeObserver loop" error.
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(fit);
      }
    });
    observer.observe(ref.current);
    return () => {
      cancelAnimationFrame(frame);
      observer.disconnect();
    };
  }, []);
  return (
    <Textarea
      ref={ref}
      rows={3}
      minH="80px"
      fontSize="xs"
      resize="none"
      overflow="hidden"
      {...props}
    />
  );
};

export default AutoGrowTextarea;
